import { setContactAdminModal } from '../../store/workspace/slice';
import { useDispatch } from '../../store/store';
import { ContactAdminIcon, LayerIcon } from '../../assets/icons';
import Button from '../../components/Button';
import Modal from '../../components/Modal';
import styles from './style.module.scss';

export default function ContactAdmin() {
    const dispatch = useDispatch();

    return (
        <Modal
            size='sm'
            icon={<LayerIcon />}
            title='Post New Job Credit'
            childClassName={styles.wrapper}
            closeFunc={() => dispatch(setContactAdminModal(false))}
        >
            <ContactAdminIcon />
            <span className={styles.text}>
                You have posted all your job post credits
            </span>
            <span className={styles.description}>
                Contact the owner of account
                to upgrade or any additional futures.
            </span>
            <div className={styles.actions}>
                <Button
                    text='Ok'
                    type='Primary'
                    className={styles.actions_btn}
                    onClick={() => dispatch(setContactAdminModal(false))}
                />
            </div>
        </Modal>
    )
}
